<template>
  <div>
    <v-row no-gutters justify="center" align="center">
      <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="$emit('previous')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="$emit('next')">
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
</style>
